<p-dialog *ngIf="canUse" [(visible)]="visible" [modal]="true" [closable]="true" (onHide)="close()"
  [style]="{width:'640px'}" [breakpoints]="{'700px':'95vw'}" styleClass="ks-dialog" [showHeader]="false"
  appendTo="body">

  <div class="ks-header">
    <div class="ks-title">
      <i class="pi pi-th-large"></i>
      <span>{{ 'shortcuts.title' | t }}</span>
    </div>
    <span class="ks-close" (click)="close()">ESC</span>
  </div>

  <div class="ks-body">
    <div class="ks-group" *ngFor="let group of groups">
      <div class="ks-group-title">{{ group.titleKey | t }}</div>
      <div class="ks-entry" *ngFor="let entry of group.entries">
        <span class="ks-entry-label">{{ entry.labelKey | t }}</span>
        <span class="ks-keys">
          <ng-container *ngFor="let key of entry.keys; let last = last">
            <kbd class="ks-key">{{ key }}</kbd><span class="ks-key-plus" *ngIf="!last">+</span>
          </ng-container>
        </span>
      </div>
    </div>
  </div>

  <div class="ks-footer">{{ 'shortcuts.macHint' | t }}</div>
</p-dialog>
